import type { MenuButton } from "@bale-bot/types";

/** Children of a folder as rows; a flat list reads as one button per row. */
export const asRows = (submenu: MenuButton["submenu"]): MenuButton[][] => {
  if (!submenu || submenu.length === 0) return [];
  return Array.isArray(submenu[0])
    ? (submenu as MenuButton[][])
    : (submenu as MenuButton[]).map((child) => [child]);
};

/** Swaps one row out; every other row keeps its identity. */
export const replaceRow = (
  rows: MenuButton[][],
  rowIndex: number,
  row: MenuButton[],
): MenuButton[][] =>
  rows.map((current, index) => (index === rowIndex ? row : current));